import AxiosConfiguration from '@/classes/AxiosConfiguration';
import {
  DocumentToStoreModel,
} from '@/types';

const EditReferencesApiUrl = 'EditReferences';

export const EditReferencesService = {
  async getDocumentToStoreAsync(sourceCabinetId: string, sourceDocumentId: number): Promise<DocumentToStoreModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(
      `${EditReferencesApiUrl}/${sourceCabinetId}/${sourceDocumentId}`
    );
    return response.data;
  },
};
